import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "../updateAction";
import { resolveImages } from "../lib/resolve-images";
import { fetchAllVariants } from "../../lib/fetch-variants";
import { mergeShopifyAndSanityProducts } from "../../lib/merge-shopify-sanity-products";

export function useVariants(section) {
  const [availableProducts, setAvailableProductsProduct] = useState([]);
  const [productGroups, setProductGroups] = useState([]);
  const [images, setImages] = useState([]);
  const {
    data: variants,
    isError,
    error,
    isLoading,
  } = useQuery(["variants", section.key], () => fetchAllVariants(availableProducts), {
    enabled: availableProducts.length > 0,
  });
  const { actions, state } = useStateMachine({ updateAction });

  useEffect(() => {
    let availableProducts = [];
    section.productGroups?.map((pg) => {
      availableProducts = pg.productReference.shopifyProducts.reduce((acc, shopifyProduct) => {
        if (shopifyProduct && shopifyProduct.productReferenceV2) {
          acc.push(shopifyProduct.productReferenceV2.handle);
        }
        return acc;
      }, availableProducts);
    });

    setAvailableProductsProduct(availableProducts);
  }, [section]);

  useEffect(() => {
    if (variants && variants.length > 0) {
      const productGroups = section.productGroups.map((pg) => {
        return mergeShopifyAndSanityProducts(pg.productReference, variants);
      });

      setProductGroups(productGroups);

      if (
        !state[`${section.key}-product`] ||
        !state[`${section.key}-variant`] ||
        !state[`${section.key}-productGroup`]
      ) {
        const updatedState = {};
        updatedState[`${section.key}-product`] = productGroups[0].shopifyProducts[0];
        updatedState[`${section.key}-variant`] =
          productGroups[0].shopifyProducts[0].productReferenceV2.variants[0];
        updatedState[`${section.key}-productGroup`] = productGroups[0];
        actions.updateAction(updatedState);
      }
    }
  }, [variants]);

  useEffect(() => {
    setImages(resolveImages(productGroups, section, state));
  }, [productGroups, state]);

  return { isError, error, isLoading, images };
}
